import { css } from "@emotion/react";

export const form = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const marginBottom = css`
  margin-bottom: 1rem;
`;

export const tosContainer = css`
  width: 100%;
`;

// The Tooltip wraps the submit button in a div that would otherwise shrink to fit,
// capping the button's own width: 100% at its natural width.
export const fullWidthTooltip = css`
  width: 100%;
`;
